import { render, staticRenderFns } from "./AthleteSideNavLayout.vue?vue&type=template&id=470915fe&"
import script from "./AthleteSideNavLayout.vue?vue&type=script&lang=ts&"
export * from "./AthleteSideNavLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports